
import { FormState__setValidationResponse_5219762A, FormState__startLoading, FormState_get_empty } from "../../../Shared/Shared.js";
import { ofArray, empty } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Msg, State } from "./Types.js";
import { Cmd_OfPromise_either, Cmd_none } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { ConsumableStockRowValidation_$reflection, ConsumableStockUpdateDto_$reflection, ConsumableStockUpdateDto } from "../../../Shared/Updater.js";
import { Cmd_OfPromise_either as Cmd_OfPromise_either_1 } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "../../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "../../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../../CommunicationV2.js";
import { Types_HttpRequestHeaders, Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { list_type, string_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { Cmd_successToast, Cmd_errorToast } from "../../../Components/Toast.js";
import { handleFetchError, ensureRequestBodySize } from "../../../ErrorHandling.js";
import { ofNullable } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { ensureValidToken } from "../../../Auth.js";
import { keyValueList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/MapUtil.js";
import { singleton, empty as empty_1, append, delay, toList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { fetch$ } from "../../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { onBlobReceived } from "../../../CommunicationV2.js";

export function init() {
    return [new State(FormState_get_empty(), empty(), "inventoryNumber", undefined, ""), Cmd_none()];
}

function extractBlob(response, filename) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response.blob().then((_arg) => (Promise.resolve([_arg, filename]))))));
}

function getBlob(response, filename) {
    return Cmd_OfPromise_either((tupledArg) => extractBlob(tupledArg[0], tupledArg[1]), [response, filename], (tupledArg_1) => (new Msg(9, [tupledArg_1[0], tupledArg_1[1]])), (Item_2) => (new Msg(10, [Item_2])));
}

export function update(msg, state) {
    switch (msg.tag) {
        case 3:
            return [new State(state.FormState, empty(), state.SelectedIdentifier, msg.fields[0], state.Comment), Cmd_none()];
        case 4:
            return [new State(state.FormState, state.Rows, state.SelectedIdentifier, state.SelectedIdentifier2, msg.fields[0]), Cmd_none()];
        case 0: {
            const dto = new ConsumableStockUpdateDto(state.Rows, state.Comment);
            return [new State(FormState__startLoading(state.FormState), state.Rows, state.SelectedIdentifier, state.SelectedIdentifier2, state.Comment), Cmd_OfPromise_either_1((tupledArg) => PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => {
                let url_2;
                return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
                    const pr = response.arrayBuffer();
                    return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
                }, refreshOn)))(true);
            })), ["/api/update/consumable-stock", toString(0, Auto_generateBoxedEncoder_437914C6(ConsumableStockUpdateDto_$reflection(), undefined, undefined, undefined)(dto))], (Item) => (new Msg(1, [Item])), (Item_1) => (new Msg(10, [Item_1])))];
        }
        case 1: {
            const response_2 = msg.fields[0];
            if (response_2.tag === 1) {
                return [new State(FormState__setValidationResponse_5219762A(state.FormState, response_2.fields[0]), state.Rows, state.SelectedIdentifier, state.SelectedIdentifier2, state.Comment), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(FormState_get_empty(), empty(), state.SelectedIdentifier, state.SelectedIdentifier2, ""), Cmd_successToast("general.saved_successfully")];
            }
        }
        case 5:
            return [new State(FormState__startLoading(state.FormState), state.Rows, state.SelectedIdentifier, state.SelectedIdentifier2, state.Comment), Cmd_OfPromise_either_1((tupledArg_1) => {
                const formData_2 = tupledArg_1[1];
                return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => {
                    let url_5;
                    ensureRequestBodySize(formData_2);
                    return ((url_5 = addPrefix(tupledArg_1[0]), (refreshOn_1) => fetchWithDecoder(url_5, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [formData_2])]), undefined, (response_3) => {
                        const pr_1 = response_3.arrayBuffer();
                        return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), list_type(ConsumableStockRowValidation_$reflection())));
                    }, refreshOn_1)))(true);
                }));
            }, ["/api/update/consumable-stock/validate", msg.fields[0]], (Item_2) => (new Msg(6, [Item_2])), (Item_3) => (new Msg(10, [Item_3])))];
        case 6: {
            const response_5 = msg.fields[0];
            if (response_5.tag === 1) {
                return [new State(FormState__setValidationResponse_5219762A(state.FormState, response_5.fields[0]), state.Rows, state.SelectedIdentifier, state.SelectedIdentifier2, state.Comment), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(FormState_get_empty(), response_5.fields[0], state.SelectedIdentifier, state.SelectedIdentifier2, state.Comment), Cmd_none()];
            }
        }
        case 7:
            return [state, Cmd_OfPromise_either_1((tupledArg_3) => {
                const body_5 = tupledArg_3[2];
                return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => {
                    let pr_2;
                    const tenant = ofNullable(localStorage.getItem("tenant"));
                    return ((pr_2 = ensureValidToken(), pr_2.then(void 0, (handleFetchError)))).then((_arg) => {
                        const headers = new Types_RequestProperties(1, [keyValueList(toList(delay(() => {
                            let matchValue;
                            return append((matchValue = _arg, (matchValue == null) ? (empty_1()) : singleton(new Types_HttpRequestHeaders(5, ["Bearer " + matchValue]))), delay(() => append(singleton(new Types_HttpRequestHeaders(11, ["Content-Disposition"])), delay(() => {
                                const matchValue_1 = tenant;
                                if (matchValue_1 == null) {
                                    return empty_1();
                                }
                                else {
                                    return singleton(["X-ONE-Tenant", matchValue_1]);
                                }
                            }))));
                        })), 0)]);
                        const props_2 = (body_5 == null) ? ofArray([new Types_RequestProperties(0, ["GET"]), headers]) : ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [body_5]), headers]);
                        return fetch$(addPrefix(tupledArg_3[0]), props_2).then((_arg_1) => (Promise.resolve([_arg_1, tupledArg_3[1]])));
                    });
                }));
            }, ["/api/update/consumable-stock/template", "verbrauchsmaterial_lagerbestand_vorlage.xlsx", undefined], (tupledArg_2) => (new Msg(8, [tupledArg_2[0], tupledArg_2[1]])), (Item_6) => (new Msg(10, [Item_6])))];
        case 8:
            return [state, getBlob(msg.fields[0], msg.fields[1])];
        case 9: {
            onBlobReceived(msg.fields[0], msg.fields[1]);
            return [state, Cmd_none()];
        }
        case 10:
            return [new State(FormState_get_empty(), state.Rows, state.SelectedIdentifier, state.SelectedIdentifier2, state.Comment), Cmd_errorToast("validation.toast")];
        default:
            return [new State(state.FormState, empty(), msg.fields[0], state.SelectedIdentifier2, state.Comment), Cmd_none()];
    }
}

